/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {
      
      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));
      
      let $sliderEl = $section.find('[data-slider]');
      
      if (this.collection_style == 'slider' || $sliderEl.length) {
        this.createSlider($sliderEl);

        const resizeNamespace = '.featuredCollection-' + ($section.attr('id') || Math.random().toString(36).slice(2));
        $(window).off('resize' + resizeNamespace).on('resize' + resizeNamespace, () => {
          clearTimeout(this._eventResizeTimer);
          this._eventResizeTimer = setTimeout(() => {
            this.createSlider($sliderEl);
          }, 150);
        });
      }

      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll("[data-product-gallery]").forEach(function (el) {
          if (el._flickity) return;
          new Flickity(el, {});
        });
      });
    },
    createSlider: function ($sliderEl) {

      const slideData = {
        products_per_slide: parseInt(this.products_per, 10) || 1,
        mobile_products_per_slide: parseInt(this.mobile_products_per, 10) || 1,
        products_available: parseInt(this.products_available, 10) || 0,
        products_limit: parseInt(this.products_limit, 10) || 0,
      }

      if (!$sliderEl.length) return;

      const isMobile = window.matchMedia('(max-width: 798px)').matches;
      const productsVisible = Math.min(slideData.products_available, slideData.products_limit);
      const productsPerView = isMobile ? slideData.mobile_products_per_slide : slideData.products_per_slide;
      const shouldSlide = productsVisible > productsPerView;
      const existing = $sliderEl.data('flickity');

      if (!shouldSlide) {
        if (existing) {
          $sliderEl.flickity('destroy');
        }
        return;
      }

      if (existing) {
        $sliderEl.flickity('resize');
        return;
      }

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: false,
        contain: true,
        prevNextButtons: shouldSlide,
        initialIndex: 0,
        // arrowShape: arrowShape
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;
